import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../../shared/helpers/icons';
import { IContact } from '../../../../shared/models/contact';
import { IDepartment } from '../../../../shared/models/department';

@Component({
  selector: 'planning-team-details',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule
  ],
  templateUrl: './planning-team-details.component.html',
  styleUrl: './planning-team-details.component.css'
})
export class PlanningTeamDetailsComponent implements OnChanges{

  icons = Icons;
  @Input() planningTeam: Array<{ collaborative_department: number | string; contact_id: number | string }> = [];
  @Input() contactsList: IContact[] = [];
  @Input() departmentsList: IDepartment[] = [];

  @Output() onClose = new EventEmitter<void>();

  departmentContacts: { department: IDepartment; contacts: IContact[] }[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    this.groupContactsByDepartment();
  }

  private groupContactsByDepartment(): void {
    if (!this.departmentsList?.length || !this.contactsList?.length) {
      this.departmentContacts = [];
      return;
    }

    // quick lookup: contact_id -> contact
    const contactById = new Map<number, IContact>(
      this.contactsList.map(c => [Number(c.id), c])
    );

    // group contact ids by department from planningTeam relationships
    const deptToContacts = new Map<number, IContact[]>();
    for (const rel of this.planningTeam ?? []) {
      const deptId = Number(rel.collaborative_department);
      const contact = contactById.get(Number(rel.contact_id));
      if (!contact) continue;

      if (!deptToContacts.has(deptId)) deptToContacts.set(deptId, []);
      deptToContacts.get(deptId)!.push(contact);
    }

    // build final array aligned with departmentsList order, dedupe + sort
    this.departmentContacts = this.departmentsList.map(dept => {
      const list = deptToContacts.get(Number(dept.id)) ?? [];
      // dedupe by id (in case planningTeam had dup rows)
      const dedup = Array.from(new Map(list.map(c => [c.id, c])).values());
      dedup.sort((a, b) => a.name.localeCompare(b.name));
      return { department: dept, contacts: dedup };
    });
  }

  closeModal(): void {
    this.onClose.emit();
  }
}

